import initialState from '../initialstate';
import * as types from '../../actions/actiontypes';
/**
 * This reducer function handles all the actions related to the top-level objects.
 * @param {Object} state - A portion of the overall Redux state, specifically the
 *      store.<%=names.camel%> object, representing the current data.
 * @param {Object} action - Action object containing type and other values
 * @return {*} current state or array of language objects
 */
export default function selectedTaskReducer(state = initialState.taskId, action) {
	switch (action.type) {
		case types.APPEND_MULTISELECT_TASK:
		case types.APPEND_MULTISELECT_TASKS:
		case types.REMOVE_MULTISELECT_TASK:
		case types.SET_IS_MULTISELECT_TASK: {
			if (state == null) {
				return state;
			}

			if (action.inputPayload && action.inputPayload.clearSelectedTask) {
				return null;
			}

			return state;
		}
		case types.SET_TASK_LIST_FILTERS: {
			if (action.payload && action.payload.clearSelectedTask) {
				return null;
			}

			return state;
		}
		case types.SET_SELECTED_TASK: {
			return action.taskId;
		}
		case types.RESET_TASK_ATTRIBUTES: {
			return action.payload.id;
		}
		case types.CLEAR_SELECTED_TASK:
		case types.RESET_TASK_CATEGORY:
		case types.CLEAR_TASKID_DATA: {
			return null;
		}
		default:
			return state;
	}
}
